export default function MediaSection() {
  return (
    <section className="py-24 bg-zinc-950">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-4xl md:text-5xl font-bold text-center mb-16 text-white">
          See It in Action
        </h2>

        <div className="grid md:grid-cols-2 gap-12 items-center">
          {/* YouTube Video */}
          <div className="relative aspect-video bg-zinc-900 rounded-2xl border border-zinc-800 overflow-hidden group">
            <iframe
              src="https://www.youtube.com/embed/GFfENxTRq44"
              title="College Mentalism Show"
              className="w-full h-full"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
          </div>

          {/* Action Photo */}
          <div className="relative aspect-[4/3] rounded-2xl overflow-hidden border border-zinc-800">
            <img
              src="https://static.readdy.ai/image/784caf738992fff872ad90f0e356a90f/824f22ccf9c7fed9a10cd62235606044.png"
              alt="Thomas performing for college students"
              className="w-full h-full object-cover object-top"
            />
          </div>
        </div>

        {/* Experience the Show */}
        <div className="mt-20">
          <h3 className="text-3xl md:text-4xl font-bold text-center mb-12 text-white">
            Experience the Show
          </h3>

          <div className="grid md:grid-cols-2 gap-10 items-start">
            {/* Full-length video */}
            <div className="flex flex-col gap-3">
              <div className="relative aspect-video bg-zinc-900 rounded-2xl border border-zinc-800 overflow-hidden">
                <iframe
                  src="https://www.youtube.com/embed/HmrRICXqZYw"
                  title="Experience the Show - Full Video"
                  className="w-full h-full"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                ></iframe>
              </div>
            </div>

            {/* YouTube Short */}
            <div className="flex flex-col gap-3">
              <div className="relative mx-auto w-full max-w-[340px] aspect-[9/16] bg-zinc-900 rounded-2xl border border-zinc-800 overflow-hidden">
                <iframe
                  src="https://www.youtube.com/embed/3DvnAxsXcvg"
                  title="Experience the Show - Short Clip"
                  className="w-full h-full"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                ></iframe>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
